/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const AccountSetDefaultVersionRequest = zod.strictObject({
    default_version: zod.number(),
});

export type AccountSetDefaultVersionRequest = zod.input<
    typeof AccountSetDefaultVersionRequest
>;
export type AccountSetDefaultVersionRequestOutput = zod.output<
    typeof AccountSetDefaultVersionRequest
>;
